/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RegistrationDataDto } from '../models/RegistrationDataDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CreatorRegistrationDataService {
    /**
     * Creates owner registration data
     * @returns any Registration data created
     * @throws ApiError
     */
    public static create({
        requestBody,
    }: {
        requestBody: RegistrationDataDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/registration-data',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Caller is not an owner`,
            },
        });
    }
    /**
     * Returns true if user should provide registration data
     * @returns boolean Returns true if owner should provide registration data
     * @throws ApiError
     */
    public static shouldProvideRegistrationData(): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/registration-data/should-fill',
        });
    }
}
